<template>
  <!-- 转入公海/长期维护/换跟进人/继续跟进表单 -->
  <el-form
    ref="formRef"
    :model="formData"
    label-width="120px"
    style="width: 550px;padding-top: 20px;"
    v-loading="loading"
  >
    <!-- 转入公海类型 -->
    <el-form-item
      v-if="['showPublicsea'].includes(modalType)"
      label="将该线索"
      prop="publicPoolType"
      :rules="[
        { required: true, message: '请选择转入公海的类型', trigger: 'change' }
      ]"
    >
      <el-radio-group v-model="formData.publicPoolType">
        <el-radio label="incubate">转入公海孵化池</el-radio>
        <el-radio label="push">转入公海推进池</el-radio>
      </el-radio-group>
    </el-form-item>
    
    <!-- 申请原因 -->
    <custom-form-item
      v-if="['showPublicsea', 'showLongTime'].includes(modalType)"
      type="input"
      labelWidth="120px"
      prop="apply_reason_formCode_FR006"
      v-model="formData.apply_reason_formCode_FR006"
      :fieldInfo="showFormFieldKeyInfo.apply_reason_formCode_FR006 || {}"
    />
    <!-- 截止时间 -->
    <custom-form-item
      v-if="['showPublicsea', 'showLongTime'].includes(modalType)"
      type="date"
      labelWidth="120px"
      prop="expired_formCode_FR006"
      v-model="formData.expired_formCode_FR006"
      :fieldInfo="showFormFieldKeyInfo.expired_formCode_FR006 || {}"
    />
    <!-- 选择跟进人 -->
    <el-form-item
      v-if="['showChangeFollower', 'showContinueFollow'].includes(modalType)"
      :label="modalType === 'showChangeFollower' ? '新跟进人' : '跟进人'"
      prop="follower"
      :rules="[
        { required: true, message: '请选择跟进人', trigger: 'blur' }
      ]"
    >
      <el-select
        v-model="formData.follower"
        style="width: 100%;"
        placeholder="请选择跟进人"
        size="small"
        clearable
        filterable
        remote
        :remote-method="remoteSearchEmployee"
      >
        <el-option v-for="item in filteredEmployeeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>
    </el-form-item> 
    <!-- 开始阶段 -->
    <el-form-item
      v-if="['showChangeFollower', 'showContinueFollow'].includes(modalType)"
      label="开始阶段"
    >
      <el-select
        v-model="formData.beginStage"
        style="width: 100%;"
        placeholder="请选择"
        disabled
        size="small"
      >
        <el-option label="信息采集" value="S020"></el-option>
        <el-option label="邀约参观" value="S040"></el-option>
      </el-select>
    </el-form-item> 
  </el-form>
</template>

<script>
import request from '@/utils/request'
import utils from '@/views/DoctorVisitLTC/utils/index'
import formFlow from '@/views/DoctorVisitLTC/common/formFlow'

const transferFormCode = 'FR006'

export default {
  name: 'TransferOrChangeClueForm',
  data() {
    return {
      loading: false,
      // 表单数据
      formData: {
        publicPoolType: '', // 转入公海类型
        apply_action_formCode_FR006: '', // 线索转为
        apply_reason_formCode_FR006: '', // 申请原因
        expired_formCode_FR006: '', // 截止时间
        follower: '', // 跟进人
        beginStage: '' // 开始阶段
      },
      fieldList: [],
      showFormFieldKeyInfo: {},
      originOptionsInfo: {},
      employeeOptions: []
    }
  },
  methods: {
    async init(modalType) {
      this.loading = true
      try {
        switch (modalType) {
          // 更换跟进人
          case 'showChangeFollower':
            this.formData.beginStage = 'S020'
            await this.getEmployeeOptions()
            break
          // 继续跟进
          case 'showContinueFollow':
            this.formData.beginStage = 'S040'
            await this.getEmployeeOptions()
            break
          // 转长期维护
          case 'showLongTime':
            await this.getFormFieldList()
            this.formData['clue_apply_id_formCode_' + transferFormCode] = await formFlow.createFormId()
            break
          // 转入公海
          case 'showPublicsea':
            await this.getFormFieldList()
            this.formData['clue_apply_id_formCode_' + transferFormCode] = await formFlow.createFormId()
            break
        }
      } catch (error) {
        console.log('初始化数据请求失败', error)
      } finally {
        this.loading = false
      }
    },

    async getFormFieldList() {
      const {
        formData,
        showFormFieldKeyInfo,
        originOptionsInfo,
        fieldList
      } = await formFlow.getFormFieldList([transferFormCode])

      this.showFormFieldKeyInfo = showFormFieldKeyInfo
      // 合并表单默认值到 formData
      this.formData = {
        ...formData,
        publicPoolType: '' // 公海线索转为
      }
      this.fieldList = fieldList
      this.originOptionsInfo = originOptionsInfo
    },

    // 获取员工列表
    async getEmployeeOptions() {
      try {
        const res = await request.get('/cluepool/pc/user/all', {}, '')
        if (res.code === 200) {
          this.employeeOptions = (res.data || []).map(item => ({
            label: item.nickName,
            value: item.workNumber
          }))
        } else {
          this.$message.error(res.message)
        }
      } catch (error) {
        console.log('请求员工列表数据请求失败', error)
      }
    },

    // 远程搜索员工
    remoteSearchEmployee(query) {
      if (query !== '') {
        this.formData.follower = query
      } else {
        this.formData.follower = ''
      }
    },

    // 表单验证（供父组件通过 ref 调用）
    validate(callback) {
      return this.$refs.formRef.validate(callback)
    },

    async submitHandle() {
      const valid = await this.$refs.formRef.validate()
      if (!valid) return false
      let requestSuccess = false
      switch (this.modalType) {
        // 更换跟进人
        case 'showChangeFollower': {
          requestSuccess = await this.submitChangeFollowerHandle('更换跟进人')
          break
        }
        // 继续跟进
        case 'showContinueFollow': {
          requestSuccess = await this.submitChangeFollowerHandle('继续跟进')
          break
        }
        // 转长期维护
        case 'showLongTime': {
          requestSuccess = await this.submitTransferLongTimeHandle()
          break
        }
        // 转入公海
        case 'showPublicsea': {
          requestSuccess = await this.submitPublicseaHandle()
          break
        }
      }
      return requestSuccess
    },

    // 更换跟进人/继续跟进
    async submitChangeFollowerHandle(typeText = '') {
      const params = {
        instanceId: this.instanceId || '',
        workNumber: this.formData.follower || ''
      }
      try {
        const res = await request.post('/cluepool/pc/form/changeWorker', params, '')
        if (res.code === 200) {
          this.$message.success(typeText + '成功')
          return true
        } else {
          this.$message.error(res.message)
          return false
        }
      } catch (error) {
        console.log('更换跟进人/继续跟进请求失败', error)
        return false
      }
    },

    // 转长期维护
    async submitTransferLongTimeHandle() {
      const { formData, fieldList} = this
      const formCodeList = [transferFormCode]
      const resultFormData = []
      for (const formCode of formCodeList) {
        resultFormData.push({
          formCode,
          fieldData: fieldList.filter(item => item.formCode === formCode).map(item => {
            let value = []
            if (['doctor_id'].includes(item.fieldName)) {
              // 处理doctor_id字段
              value = this.doctorId ? [this.doctorId] : []
            } else if (['apply_action'].includes(item.fieldName)) {
              value = ['S030']
            } else {
              value = utils.isEmpty(formData[item.resultFieldName]) ? [] : [formData[item.resultFieldName]]
            }
            return {
              formFieldCode: item.fieldCode,
              fieldName: item.fieldName,
              zhName: item.zhName,
              value
            }
          })
        })
      }
      const params = {
        flowInstanceId: this.instanceId,
        followAction: 'S030',
        formData: resultFormData,
        stepCode: this.stepCode,
        stepId: this.stepId
      }
      try {
        const res = await formFlow.submitFormData(params)
        if (res.code === 200) {
          this.$message.success('转长期维护成功')
          return true
        } else {
          this.$message.error(res.message)
          return false
        }
      } catch (error) {
        console.log('转长期维护失败', error)
        return false
      }
    },

    // 转入公海
    async submitPublicseaHandle() {
      // todo:对接转公海接口，需要知道是转入公海孵化池还是推进池
      return false
    },

    // 重置表单（供父组件通过 ref 调用）
    resetFields() {
      this.$refs.formRef.resetFields()
    }
  },
  created() {
    // 组件创建时根据 modalType 加载数据
    if (this.modalType) {
      this.init(this.modalType)
    }
  },
  props: {
    instanceId: {
      type: String,
      default: ''
    },
    doctorId: {
      type: String,
      default: ''
    },
    stepCode: {
      type: String,
      default: ''
    },
    stepId: {
      type: String,
      default: ''
    },
    // 弹窗类型(showPublicsea/showLongTime/showChangeFollower/showContinueFollow)
    modalType: {
      type: String,
      default: ''
    }
  },
  computed: {
    // 过滤后的员工列表
    filteredEmployeeOptions() {
      if (!this.formData.follower) {
        return []
      }
      // 根据搜索关键字过滤员工列表
      const keyword = this.formData.follower.toString().toLowerCase()
      return this.employeeOptions.filter(item => 
        item.label.toString().toLowerCase().includes(keyword) || 
        item.value.toString().toLowerCase().includes(keyword)
      )
    }
  },
  components: {
    CustomFormItem: () => import('@/views/DoctorVisitLTC/components/customFormItem/CustomFormItem.vue'),
  }
}
</script>
